import React from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';

const pad = (number) => String(number).padStart(2, '0');

const formatDateTimeForRails = (date) => {
  if (!date) return '';

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};

const parseDateTimeFromRails = (value) => {
  if (!value) return null;

  const parsed = new Date(value.replace(' ', 'T'));
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

class DateTimePickerField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedAt: parseDateTimeFromRails(props.initialValue)
    };
  }

  onChange = (selectedAt) => {
    this.setState({ selectedAt });
  };

  render() {
    const { fieldName, label, timeCaption } = this.props;
    const { selectedAt } = this.state;

    return (
      <div className="form-group">
        <label htmlFor={fieldName} className="d-block">{label}</label>
        <input type="hidden" readOnly name={fieldName} value={formatDateTimeForRails(selectedAt)} />
        <DatePicker
          id={fieldName}
          className="form-control"
          showTimeSelect
          timeIntervals={30}
          timeFormat="HH:mm"
          dateFormat="yyyy-MM-dd HH:mm"
          onChange={this.onChange}
          selected={selectedAt}
          timeCaption={timeCaption}
          placeholderText="YYYY-MM-DD HH:MM"
        />
      </div>
    );
  }
}

DateTimePickerField.propTypes = {
  fieldName: PropTypes.string.isRequired,
  initialValue: PropTypes.string,
  label: PropTypes.string.isRequired,
  timeCaption: PropTypes.string
};

DateTimePickerField.defaultProps = {
  initialValue: '',
  timeCaption: 'Time'
};

export default DateTimePickerField;